import { Alert } from '@backstage/ui';

interface ConfigurationErrorProps {
  errors: string[];
}

export const ConfigurationError = ({ errors }: ConfigurationErrorProps) => {
  if (errors.length === 0) {
    return null;
  }

  return (
    <Alert
      status="danger"
      icon
      title="Erros de configuração"
      description={errors.join(', ')}
    />
  );
};
